"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function reducerCreator(initialState) {
    return (state = initialState, action) => {
        switch (action.type) {
            case 'search': {
                state.keyword = action.keyword.toLowerCase().trim();
                state.results = { arrangements: {}, news: [], tickets: [] };
                state.total = 0;
                debugger;
                if (state.keyword !== '') {
                    const filmResult = [];
                    state.arrangements
                        .filter(i => i.object === "movie" && i.filmTitle && i.filmTitle.toLowerCase().indexOf(state.keyword) !== -1)
                        .map(event => {
                        if (filmResult.length === 0 || filmResult.every(a => a.filmTitle !== event.filmTitle)) {
                            filmResult.push(event);
                            return event;
                        }
                    });
                    const cultureResult = [];
                    state.arrangements
                        .filter(i => i.object === "culture" && i.cultureTitle && i.cultureTitle.toLowerCase().indexOf(state.keyword) !== -1)
                        .map(event => {
                        if (cultureResult.length === 0 || cultureResult.every(a => a.cultureTitle !== event.cultureTitle)) {
                            cultureResult.push(event);
                            return event;
                        }
                    });
                    state.results.tickets = state.tickets;
                    state.results.arrangements.films = filmResult;
                    state.results.arrangements.culture = cultureResult;
                    state.total += state.results.arrangements.films.length + state.results.arrangements.culture.length;
                    // News
                    state.results.news = state.news.filter(i => i.title.toLowerCase().indexOf(state.keyword) !== -1);
                    state.total += state.results.news.length;
                }
                return Object.assign({}, state);
            }
            default: return state;
        }
    };
}
exports.reducerCreator = reducerCreator;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-search-field/state/reducerCreator.ts